import type { CloneRouteGeometry } from "./types";

export const cloneRouteGeometry: CloneRouteGeometry = ({ nodes, edges }) => ({
  nodes: nodes.map((node) => ({ id: node.id, x: node.x, y: node.y })),
  edges: edges.map((edge) => ({ from: edge.from, to: edge.to })),
});
